module.exports = __webpack_public_path__ + "img/angle-down-solid.75a1ebbe.svg";